import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import events from '@kfc-global/react-shared/analytics/Register';
import { getDataLayer } from 'common/utilities/utils';

export const ViewFavMenu = async itemsArray => {
  await AnalyticsService.registerEvent(
    events.accountViewFavItemList.name,
    {
      data: {
        event: 'view_item_list',
        ecommerce: {
          // item_list: {
          items: itemsArray,
          // },
        },
      },
    },
    getDataLayer,
  );
};
